/* eslint no-param-reassign: "off" */
import * as types from './mutation-types';

export default {
  /*
   * Channels
   */
  [types.SET_CHANNELS]: (state, channels) => {
    state.channels = channels;
  },

  [types.GET_CHANNELS_REQUEST]: state => {
    state.loadingChannels = true;
    state.getChannelsRequestFailed = false;
    state.getChannelsRequestSuccess = false;
  },
  [types.GET_CHANNELS_FAILURE]: (state, error) => {
    state.loadingChannels = false;
    state.loadingChannelsFailed = true;
    state.loadingChannelsError = error;
  },
  [types.GET_CHANNELS_SUCCESS]: (state, response) => {
    state.loadingChannels = false;
    state.loadingChannelsSuccess = true;
    state.channels = response.data.results;
  },

  /*
   * Channel links
   */
  [types.GET_CHANNEL_LINKS_REQUEST]: state => {
    state.loadingChannelLinks = true;
    state.loadChannelLinksFailed = false;
    state.loadChannelLinksSuccess = false;
  },
  [types.GET_CHANNEL_LINKS_FAILURE]: (state, error) => {
    state.loadingChannelLinks = false;
    state.loadChannelLinksFailed = true;
    state.loadChannelLinksError = error;
  },
  [types.GET_CHANNEL_LINKS_SUCCESS]: (state, payload) => {
    state.loadingChannelLinks = false;
    state.loadChannelLinksFailed = true;
    const campaign = payload.rootState.campaign.campaigns.filter(c => c.id === payload.campaign);
    if (campaign) {
      campaign[0].channelLinks = payload.response.data.results;
    }
  },

  /*
   * Selected channels
   */
  [types.SET_SELECTED_CHANNELS]: (state, payload) => {
    state.selectedChannels = payload;
  },
  [types.CLEAR_SELECTED_CHANNELS]: state => {
    state.selectedChannels = [];
  },

  /**
   * Facebook
   */
  [types.POLL_FACEBOOK_PAGES_START]: (state, interval) => {
    state.facebookPagePollInterval = interval;
  },

  [types.POLL_FACEBOOK_PAGES_STOP]: state => {
    state.facebookPagePollInterval = clearInterval(state.facebookPagePollInterval);
  },

  [types.CLEAR_ADD_FACEBOOK_CHANNEL_STATE]: state => {
    state.gettingFacebookPages = false;
    state.facebookPages = [];
  },

  [types.GET_FACEBOOK_PAGES_REQUEST]: state => {
    state.gettingFacebookPages = true;
  },

  [types.GET_FACEBOOK_PAGES_SUCCESS]: (state, data) => {
    state.gettingFacebookPages = false;
    if (data.constructor !== String) {
      state.facebookPages = data;
    }
  },

  [types.GET_FACEBOOK_PAGES_FAILURE]: state => {
    state.gettingFacebookPages = false;
  },

  [types.ADD_FACEBOOK_PAGE_REQUEST]: state => {
    state.addingFacebookPage = true;
  },

  [types.ADD_FACEBOOK_PAGE_SUCCESS]: state => {
    state.addingFacebookPage = false;
  },

  [types.ADD_FACEBOOK_PAGE_FAILURE]: state => {
    state.addingFacebookPage = false;
  },

  [types.ADD_INSTAGRAM_CHANNEL_REQUEST]: state => {
    state.addingInstagramChannel = true;
  },

  [types.ADD_INSTAGRAM_CHANNEL_DONE]: state => {
    state.addingInstagramChannel = false;
  },

  [types.ADD_TWITTER_CHANNEL_REQUEST]: state => {
    state.addingTwitterChannel = true;
  },

  [types.ADD_TWITTER_CHANNEL_DONE]: state => {
    state.addingTwitterChannel = false;
  },

  [types.ADD_EMAIL_CHANNEL_REQUEST]: state => {
    state.addingEmailChannel = true;
  },

  [types.ADD_EMAIL_CHANNEL_DONE]: state => {
    state.addingEmailChannel = false;
  },

  [types.ADD_TIKTOK_CHANNEL_REQUEST]: state => {
    state.addingTiktokChannel = true;
  },

  [types.ADD_TIKTOK_CHANNEL_DONE]: state => {
    state.addingTiktokChannel = false;
  },

  [types.ADD_WECHAT_CHANNEL_REQUEST]: state => {
    state.addingWechatChannel = true;
  },

  [types.ADD_WECHAT_CHANNEL_DONE]: state => {
    state.addingWechatChannel = false;
  },

  [types.ADD_WHATSAPP_CHANNEL_SUCCESS]: state => {
    state.addingWhatsappChannel = false;
  },

  [types.ADD_WHATSAPP_CHANNEL_FAILURE]: state => {
    state.addingWhatsappChannel = false;
  },

  [types.ADD_WHATSAPP_CHANNEL_REQUEST]: state => {
    state.addingWhatsappChannel = true;
  },

  [types.GET_WHATSAPP_AUTH_CODE_REQUEST]: state => {
    state.requestingWhatsappCode = true;
  },

  [types.GET_WHATSAPP_AUTH_CODE_SUCCESS]: state => {
    state.requestingWhatsappCode = false;
    state.requestWhatsappAuthCodeSuccess = true;
  },

  [types.GET_WHATSAPP_AUTH_CODE_FAILURE]: state => {
    state.requestingWhatsappCode = false;
    state.requestWhatsappAuthCodeFailure = true;
    state.requestWhatsappAuthCodeSuccess = true;
  },

  /**
   * Instagram
   */
  [types.POLL_INSTAGRAM_PAGES_START]: (state, interval) => {
    state.instagramPagePollInterval = interval;
  },

  [types.POLL_INSTAGRAM_PAGES_STOP]: state => {
    state.instagramPagePollInterval = clearInterval(state.instagramPagePollInterval);
  },

  [types.CLEAR_ADD_INSTAGRAM_CHANNEL_STATE]: state => {
    state.gettingInstagramPages = false;
    state.instagramPages = [];
  },

  [types.GET_INSTAGRAM_PAGES_REQUEST]: state => {
    state.gettingInstagramPages = true;
  },

  [types.GET_INSTAGRAM_PAGES_SUCCESS]: (state, data) => {
    state.gettingInstagramPages = false;
    if (data.constructor !== String) {
      state.instagramPages = data;
    }
  },

  [types.GET_INSTAGRAM_PAGES_FAILURE]: state => {
    state.gettingInstagramPages = false;
  },

  [types.ADD_INSTAGRAM_PAGE_REQUEST]: state => {
    state.addingInstagramPage = true;
  },

  [types.ADD_INSTAGRAM_PAGE_SUCCESS]: state => {
    state.addingInstagramPage = false;
  },

  [types.ADD_INSTAGRAM_PAGE_FAILURE]: state => {
    state.addingInstagramPage = false;
  },

  [types.UPDATE_CHANNEL_REQUEST]: state => {
    state.updateChannelRequest = true;
    state.updateChannelSuccess = false;
    state.updateChannelFailed = false;
  },

  [types.UPDATE_CHANNEL_SUCCESS]: state => {
    state.updateChannelRequest = false;
    state.updateChannelSuccess = true;
    state.updateChannelFailed = false;
  },

  [types.UPDATE_CHANNEL_FAILURE]: state => {
    state.updateChannelRequest = false;
    state.updateChannelSuccess = false;
    state.updateChannelFailed = true;
  },

  [types.GET_TIKTOK_CREATOR_INFO_REQUEST](state) {
    state.tiktokCreatorLoading = true;
    state.tiktokCreator = null;
    state.tiktokCreatorError = null;
  },

  [types.GET_TIKTOK_CREATOR_INFO_SUCCESS](state, payload) {
    state.tiktokCreatorLoading = false;
    state.tiktokCreator = payload;
  },

  [types.GET_TIKTOK_CREATOR_INFO_FAILURE](state, error) {
    state.tiktokCreatorLoading = false;
    state.tiktokCreatorError = error;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/channel/mutations.js